module.exports = __webpack_public_path__ + "img/03-12.5621acfe.png";